import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useRef, useCallback, useEffect } from 'react';

function useHandlePlayerError() {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    reportableError = _useState2[0],
    setReportableError = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var alreadyGotAnError = useRef(false);
  var timeout = useRef();
  var handleReportableError = useCallback(function (receivedError) {
    if (alreadyGotAnError.current) return;
    alreadyGotAnError.current = true;
    setReportableError(receivedError);
    // Wait a little to give consumers the chance to report the error
    timeout.current = setTimeout(function () {
      setError(receivedError);
    }, 100);
  }, []);
  var handleError = useCallback(function (receivedError) {
    if (alreadyGotAnError.current) return;
    alreadyGotAnError.current = true;
    setError(receivedError);
  }, []);

  // Clear timeout on unmount
  useEffect(function () {
    return function () {
      if (timeout.current) clearTimeout(timeout.current);
    };
  }, []);
  return {
    reportableError: reportableError,
    error: error,
    handleReportableError: handleReportableError,
    handleError: handleError
  };
}

export { useHandlePlayerError };
//# sourceMappingURL=useHandlePlayerError.js.map
